import Stockholm from 'stockholm-js';
import parseNewick from '../parseNewick';
import { generateNodeIds } from '../util';
export default class StockholmMSA {
    constructor(text, currentAlignment) {
        const res = Stockholm.parseAll(text);
        this.data = res;
        this.MSA = res[currentAlignment];
    }
    getMSA() {
        return this.MSA;
    }
    getRow(name) {
        var _a, _b;
        return (_b = (_a = this.MSA) === null || _a === void 0 ? void 0 : _a.seqdata[name]) === null || _b === void 0 ? void 0 : _b.split('');
    }
    getWidth() {
        var _a;
        const name = Object.keys((_a = this.MSA) === null || _a === void 0 ? void 0 : _a.seqdata)[0];
        return this.getRow(name).length;
    }
    get alignmentNames() {
        return this.data.map((aln, idx) => { var _a; return ((_a = aln.gf.DE) === null || _a === void 0 ? void 0 : _a[0]) || `Alignment ${idx + 1}`; });
    }
    getHeader() {
        var _a, _b;
        return {
            General: this.MSA.gf,
            Accessions: (_a = this.MSA.gs) === null || _a === void 0 ? void 0 : _a.AC,
            Dbxref: (_b = this.MSA.gs) === null || _b === void 0 ? void 0 : _b.DR,
        };
    }
    getRowData(rowName) {
        var _a, _b, _c, _d;
        return {
            name: rowName,
            accession: (_b = (_a = this.MSA.gs) === null || _a === void 0 ? void 0 : _a.AC) === null || _b === void 0 ? void 0 : _b[rowName],
            dbxref: (_d = (_c = this.MSA.gs) === null || _c === void 0 ? void 0 : _c.DR) === null || _d === void 0 ? void 0 : _d[rowName],
        };
    }
    getNames() {
        return Object.keys(this.MSA.seqdata);
    }
    getSeqCoords() { }
    getStructures() {
        var _a;
        const pdbRegex = /PDB; +(\S+) +(\S); ([0-9]+)-([0-9]+)/;
        const ent = this.MSA;
        const args = Object.entries(((_a = ent.gs) === null || _a === void 0 ? void 0 : _a.DR) || {})
            .map(([id, dr]) => [id, pdbRegex.exec(dr)])
            .filter((item) => !!item[1])
            .map(([id, match]) => {
            const pdb = match[1].toLowerCase();
            const chain = match[2];
            const startPos = +match[3];
            const endPos = +match[4];
            return { id, pdb, chain, startPos, endPos };
        });
        const ret = {};
        for (const entry of args) {
            const { id, ...rest } = entry;
            if (!ret[id]) {
                ret[id] = [];
            }
            ret[id].push(rest);
        }
        return ret;
    }
    getTree() {
        var _a, _b, _c;
        const tree = (_c = (_b = (_a = this.MSA) === null || _a === void 0 ? void 0 : _a.gf) === null || _b === void 0 ? void 0 : _b.NH) === null || _c === void 0 ? void 0 : _c[0];
        return tree
            ? generateNodeIds(parseNewick(tree))
            : {
                id: 'root',
                name: 'root',
                noTree: true,
                branchset: this.getNames().map(name => ({
                    id: name,
                    branchset: [],
                    name,
                })),
            };
    }
    get seqConsensus() {
        var _a;
        return (_a = this.MSA.gc) === null || _a === void 0 ? void 0 : _a.seq_cons;
    }
    get secondaryStructureConsensus() {
        var _a;
        return (_a = this.MSA.gc) === null || _a === void 0 ? void 0 : _a.SS_cons;
    }
    get tracks() {
        return [
            {
                id: 'seqConsensus',
                name: 'Sequence consensus',
                data: this.seqConsensus,
                customColorScheme: {},
            },
            {
                id: 'secondaryStruct',
                name: 'Secondary-structure',
                data: this.secondaryStructureConsensus,
                customColorScheme: {
                    '>': 'pink',
                    '<': 'lightblue',
                },
            },
        ];
    }
}
//# sourceMappingURL=StockholmMSA.js.map